<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base class="sample-overview" :busy="loadingSampleCollection">
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>Sample Request</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body" v-if="sampleCount > 0">
                    <b-container>
                        <b-row>
                            <b-col md="8">
                                <div>
                                    <h6 class="d-none pl-0 d-lg-block">LIST OF SAMPLES</h6>
                                </div>
                                <transition-group name="list" tag="div">
                                    <sample-overview-item :key="item.id" v-for="(item) in sampleItemList" :item="item"/>

                                </transition-group>

                                <!--<router-link :to="{ name: 'checkout', params: {cartId: cart.id}}" tag="button"-->
                                <!--class="btn btn-block my-2 btn-primary d-lg-none">GO TO CHECKOUT-->
                                <!--</router-link>-->
                                <!--<div :key="item" v-for="(item) in cart.shoppingCartItemList">-->
                                <!--<mq-layout mq="lg+">-->
                                <!--<cart-overview-item :cart="cart" :item="itemArray[item]"/>-->
                                <!--</mq-layout>-->
                                <!--<mq-layout :mq="['sm', 'md']">-->
                                <!--<cart-overview-item-mobile :cart="cart" :item="itemArray[item]"/>-->
                                <!--</mq-layout>-->
                                <!--</div>-->
                            </b-col>
                            <b-col md="4" class="d-none d-lg-block">
                                <h6>ORDER SUMMARY</h6>
                                <router-link :to="{ name: 'sample-checkout'}" tag="button"
                                             class="btn btn-block btn-primary btn-lg">GO TO CHECKOUT
                                </router-link>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
                <template slot="body" v-else>
                    <b-container>
                        <b-row>
                            <b-col>
                                <b-alert variant="warning" show>No samples added yet.</b-alert>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>

<script>


    import {mapActions, mapGetters, mapState} from "vuex";
    import SampleOverviewItem from "./SampleOverviewItem";

    export default {
        name: 'sample-overview',
        props: {},
        components: {
            SampleOverviewItem
        },
        data() {
            return {
                busy: false
            };
        },
        methods: {
            ...mapActions("sample", ["fetchSampleList"]),
        },
        computed: {
            ...mapState("sample", ['loadingSampleCollection']),
            ...mapGetters('sample', ['sampleItemList', 'sampleCount']),
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
